import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as AddingCardIcon } from '../../../../assets/images/AnimatedCards.svg';

export const AddingCard = () => {
  const { t } = useTranslation();

  return (
    <div className="adding-card">
      <div className="adding-card__icon-container">
        <AddingCardIcon className="adding-card__icon-container__icon" />
      </div>
      <div className="adding-card-message">{t('accountSettings.addingCard')}</div>
    </div>
  );
};
